import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { borderRadius, colors, grid } from './constants';
import type, { DraggableProvided } from 'react-beautiful-dnd';
import { path } from 'ramda';
import styles from './styles';
import Preloader from '../../common/Preloader';
import {push} from "react-router-redux";
import {Link} from "react-router-dom";

const Container = styled.span`
  border-radius: ${borderRadius}px;
  background-color: ${({isDragging}) => (isDragging ? colors.green : colors.white)};
  /* cursor: grabbing is handled by app */
  cursor: grab;
  box-shadow: ${({isDragging}) => (isDragging ? `2px 2px 1px ${colors.shadow}` : 'none')};
  padding: ${grid}px;
  min-height: 40px;
  margin-bottom: ${grid}px;
  margin-right: -10px;
  margin-left: -7px;
  user-select: none;
  transition: background-color 0.1s ease;
  /* anchor overrides */
  color: ${colors.black};
  &:hover {
    color: ${colors.black};
    text-decoration: none;
  }
  &:focus {
    outline: 2px solid ${colors.purple};
    box-shadow: none;
  }
  /* flexbox */
  display: flex;
  align-items: center;
`;

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: ${grid}px;
  flex-shrink: 0;
  flex-grow: 0;
`;

const Content = styled.div`
  /* flex child */
  flex-grow: 1;
  /* Needed to wrap text in ie11 */
  /* https://stackoverflow.com/questions/35111090/why-ie11-doesnt-wrap-the-text-in-flexbox */
  flex-basis: 100%
  /* flex parent */
  display: flex;
  flex-direction: column;
`;

const BlockQuote = styled.div`
  &::before {
    content: open-quote;
  }
  &::after {
    content: close-quote;
  }
`;

const Footer = styled.div`
  display: flex;
  font-size: 10px;
  width: 100%;
`;

const QuoteId = styled.small`
  flex-grow: 0;
  margin: 0;
`;

const Attribution = styled.small`
  margin: 0;
  margin-left: ${grid}px;
  text-align: right;
  flex-grow: 1;
`;

export default class QuoteItem extends Component {
  constructor(props) {
    super(props);
    this.renderLabeles = this.renderLabeles.bind(this);
    this.redirectToPage = this.redirectToPage.bind(this);
    this.showPreView = this.showPreView.bind(this);
  }

  componentDidMount() {
    if (!this.props.autoFocus) {
      return;
    }

    const node = ReactDOM.findDOMNode(this);

    node.focus();
  }

  getLaneById(lanes, id) {
    for (let i = lanes.length; i--;) {
      if (lanes[i].id === id) {
        return lanes[i];
      }
    }
    return null;
  }

  cutLabel(label) {
    if (window.mobilecheck()) {
      label = label.substring(0, 5) + '...';
    }

    return label;
  }

  splitDescription(str) {
    if (str && str.length > 25) {
      /*let finalIteration = null;
       let result = '';
       const arrParts = str.split(' ');

       for (let i = 0; i < arrParts.length; i++) {
       if (arrParts[i].length >= 11) {
       finalIteration = i;
       break;
       }
       }

       if (finalIteration !== null) {
       for (let i = 0; i < finalIteration; i++) {
       result += ' ' + arrParts[i];
       }

       return result + ' ... ';
       } else {
       result = str;
       }

       if (result.indexOf('#') !== -1) {
       result = result.split('#').join(' #');
       }

       return result;*/

      let result = str.substring(0, 22);

      return result + '...';
    }

    if (str && str.indexOf('#') !== -1) {
      str = str.split('#').join(' #');
    }

    return str;
  }

  renderLabeles() {
    const labels = [];
    let lane = path(['quote', 'lane'], this.props);
    const { extraFieldToShow } = this.props;
    let desctopStyles = {
      width: '100%',
      whiteSpace: 'normal',
      lineHeight: '0.8',
    };

    const workShopField = extraFieldToShow.filter((value) => value.type === 'workshop')[0];
    if (!workShopField) return;
    if (lane === 0) {
      labels.push(
        <span
          className="badge badge-outline badge-danger badge-sm"
          style={desctopStyles}
        >
          None
        </span>
      );
    } else {
      let currentLane = this.getLaneById(this.props.lanesList, lane);
      let laneName = null;

      if (currentLane) {
        laneName = currentLane.label;

        labels.push(
          <span
            className="badge badge-outline badge-info badge-sm"
            style={desctopStyles}
          >
            {this.cutLabel(laneName)}
          </span>
        );
      } else {
        labels.push(
          <span
            className="badge badge-outline badge-danger badge-sm"
            style={desctopStyles}
          >
            None
          </span>
        );
      }
    }

    return (
      <Footer>
        {labels}
      </Footer>
    );
  }

  redirectToPage(id) {
    this.props.handlerOpenTask(id);
  }

  showPreView(id) {
    this.props.handlerOpenPreView(id);
  }

  renderCommented(enabled) {
    if (enabled) {
      return <Link to={'/pages/comments/' + this.props.quote.task_id} style={{color: 'green'}}>
        <i
          title="Comment(s) Added"
          className="fa fa-comment-o"
          style={{
            marginLeft: '3px',
            marginTop: '8px',
            float: 'right',
          }}
        ></i>
      </Link>;
    }
    return null;
  }

  renderAttached(enabled) {
    if (enabled) {
      return <Link to={'/pages/attach/' + this.props.quote.task_id} style={{color: 'green'}}>
        <i
          title="Attachment(s) Uploaded"
          className="fa fa-files-o"
          style={{
            marginLeft: '30%',
            marginTop: '8px',
          }}
        ></i>
      </Link>;
    }
    return null;
  }

  renderDC(enable, exist) {
    if (enable === 'Yes' || exist) {
      return <Link to={'/pages/attach/' + this.props.quote.task_id} style={{color: exist ? 'green' : 'red'}}>
        <p
          title={exist ? "Quality Control results Uploaded" : "Quality Control Required"}
          style={{
            marginLeft: '30%',
            marginTop: '8px',
            marginBottom: 0
          }}
        >QC</p>
      </Link>;
    }
  }

  addMobileStyles() {
    if (window.mobilecheck()) {
      return 'mobile-scale';
    }

    return '';
  }

  render() {
    const {quote, isDragging, provided, extraFieldToShow} = this.props;
    provided.draggableStyle.borderLeft = '4px solid ' + quote.color_status;

    const has_qc_docs = this.props.quote.has_qc_docs;
    const attached = path(['attached'], quote) || false;
    const commented = path(['commented'], quote) || false;
    let qc = '';
    try {
      qc = this.props.quote[`extra_${this.props.extraFieldToShow.filter(field => field.type === "quantity_control")[0].id}`];
    } catch (e) {}
    // const material = path(['quote', 'material'], quote) || false;
    // const priority = path(['quote', 'priority'], quote) || false;
    // const due_date = path(['quote', 'due_date'], quote) || false;
    const contentStyles = {
      flexGrow: '1',
      flexBasis: '100%',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    };
    const containerStyles = {};

    if (this.props.isFullScreen) {
      if (window.mobilecheck()) {
        provided.draggableStyle.width = '85px';
      } else {
        provided.draggableStyle.maxWidth = '120px';
      }
    } else {
      delete provided.draggableStyle.width;
    }

    let iconStyles = {
      position: 'relative',
      top: '15px',
    };

    if (window.mobilecheck()) {
      iconStyles.right = '20px';
    }

    let desctopLabelsStyles = {};
    let itemHeaderTitle = {padding: '0 0 0 15px'};
    let itemHeaderInfoDiv = {marginLeft: '0'};
    let desctopIconStyles = {display: 'flex'};

    if (!window.mobilecheck()) {
      desctopLabelsStyles = {
        transform: 'scale(0.8)',
        padding: 0,
        paddingLeft: '5px',
        width: '100%',
      };
    }
    let propertyContainerStyle = {
      margin: '4px 0',
      fontSize: '10px',
      maxWidth: '90%',
    };
    let propertyStyle = {
      fontSize: '10px',
    };
    let descriptionStyles = {
      fontSize: '10px',
    };
    let descriptionContainerStyles = {
      maxWidth: '90%',
    };

    if (window.mobilecheck()) {
      itemHeaderTitle = {padding: '0 0 0 5%'};
      propertyContainerStyle = {
        maxWidth: '100%',
        fontSize: '7px',
      };
      descriptionStyles = {
        fontSize: '7px',
      };
      descriptionContainerStyles = {
        maxWidth: '100%',
      };
      itemHeaderInfoDiv = {
        marginLeft: '-5%',
      }
    }

    let task = (
      <div style={contentStyles}>
        <div className="row">
          <div style={styles.itemHeader}>
            <div
              onClick={() => {
                localStorage.setItem('cameToWOFrom', 'dashboard');
                this.redirectToPage(quote.task_id);
              }}
              style={{...itemHeaderTitle, ...styles.itemHeaderTitle}}
              className={`col-12 ${this.addMobileStyles()}`}
            >
              {quote.task_name}
            </div>
            <div style={{...styles.itemHeaderInfoDiv, ...itemHeaderInfoDiv}}>
              <span className="fa-stack" style={{color: this.props.quote.color_status, ...styles.itemHeaderInfo}}
                    onClick={() => {
                      localStorage.setItem('cameToWOInfoFrom', 'dashboard');
                      this.showPreView(quote.task_id);
                    }}>
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-info fa-stack-1x fa-inverse"></i>
              </span>
            </div>
          </div>
          <div className={`col-12 dashboard-property`} style={propertyContainerStyle}>
            {
              extraFieldToShow.map((field) => {
                const value = quote[`extra_${field.id}`];
                if (!value || field.label == 'Quality Control') {
                  return;
                }

                return (
                  <div>
                    <b>{`${field.label}: `}</b><span>{this.splitDescription(value)}</span>
                  </div>
                )
              })
            }
          </div>
          <div className={`col-12 ${this.addMobileStyles()}`} style={desctopLabelsStyles}>
            {this.renderLabeles()}
          </div>
          <div className={`info-task col-12 ${this.addMobileStyles()}`} style={desctopIconStyles}>
            {this.renderCommented(commented)}
            {this.renderAttached(attached)}
            {this.renderDC(qc, has_qc_docs)}
          </div>
        </div>
      </div>
    );
    if (quote.task_name === undefined) {
      task = (
        <div style={{width: '100%', textAlign: 'center !important'}}>
          <Preloader
            show={true}
            type={'circle'}
            size={'20px'}
            padding={'0px'}
          />
        </div>
      );
    }

    return (
      <Container
        isDragging={isDragging}
        innerRef={provided.innerRef}
        style={provided.draggableStyle}
        {...provided.dragHandleProps}
      >
        {task}
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Item.js